// store/customer.js
import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface IRedirectState {
	customerId: string | null;
	fimenu: string | null;
	emailCode: string | null;
	isEmailVerified: boolean;
	isEditMode: boolean;
	editModeLink: string | null;
	emailVerifiedOutOfStoreLink: string | null;
	emailNotVerifiedLink: string | null;
}

export const useRedirectStore = defineStore('redirect', () => {
	const customerId = ref<string>(null);
	const fimenu = ref<string>(null);
	const emailCode = ref<string>(null);
	const isEmailVerified = ref(false);
	const isEditMode = ref(false);
	const editModeLink = ref<string>(null);
	const emailVerifiedOutOfStoreLink = ref<string>(null);
	const emailNotVerifiedLink = ref<string>(null);

	const setRedirectParams = (params: IRedirectState) => {
		customerId.value = params.customerId;
		fimenu.value = params.fimenu;
		emailCode.value = params.emailCode;
		isEmailVerified.value = params.isEmailVerified;
		isEditMode.value = params.isEditMode;
		editModeLink.value = params.editModeLink;
		emailVerifiedOutOfStoreLink.value = params.emailVerifiedOutOfStoreLink;
		emailNotVerifiedLink.value = params.emailNotVerifiedLink;
	};

	return {
		customerId,
		fimenu,
		emailCode,
		isEmailVerified,
		isEditMode,
		editModeLink,
		emailVerifiedOutOfStoreLink,
		emailNotVerifiedLink,
		setRedirectParams,
	};
});
